// react-bootstrap imports
import { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Button, Spinner } from "react-bootstrap"

// components imports
import { BotaoVoltar, CustomTooltip } from "components/Helpers"
import { BotaoComModalConfirmacao } from "components/Modals"
import { ButtonVer, Tabela } from "components/Tabela"

// service imports
import { filterDocumentosQueParticipo } from "services/components/Filtro"
import { userData, userHasAccess, userLogado } from "services/LoginFunctions"
import { excluirDocumentoPorID, BaixarDocFromID, oficializarDocumentoPorID, oficializarMulta, PegarProcessoPorID } from "services/CallAPIs"

// assets imports
import iconGerarDoc from "assets/icon_gerarDoc.png"
import iconPdf from "assets/icon_pdf.png"
import iconEdit from "assets/icon_edit.png"
import iconOficializar from "assets/icon_oficializar.png"
import iconTrash from "assets/icon_trash.png"
import stdStyle from "json/StdStyles.json"

import { ROLE } from "constants/userRoles"
import * as Links from "constants/links"
import {tipoImovelNome} from "constants/tiposImovel"
import {TIPO, TIPONOME} from "constants/tiposDoc"


const btnStyle = "rounded-4 mx-2 my-auto btn btn-primary"
const btnVariant = "outline-primary"

const MsgNaoHaDadosDoProcesso = <div className={stdStyle.form}>
                                    <p className = "fw-bold mt-3 align-self-center">Não há dados do processo</p>
                                </div>

// const MsgNaoHaDocumentosNoProcesso = <div className={stdStyle.form}>
//                                     <p className = "fw-bold mt-3 align-self-center">Não há documentos no processo</p>
//                                 </div>


const ButtonVerDocumento = ({ procData, docData, prevState }) =>
{
    // const disabled = !(docData.tipoDoc === "GuiaPag" || docData.tipoDoc === "AutObrasInfra")
    return (
        <ButtonVer url={Links.VER_DOCUMENTO} state={{docData: docData, procData: procData, statePrevPage: prevState, linkPrevPage: Links.VER_PROCESSO}} text={"Ver Documento"} altText={"Botão para visualizar o documento"} />
    )
}        
    
const ButtonEditarDocumento = ({ procData, docData, prevState }) =>
{
    const navigate = useNavigate()
    const enabled = !docData.oficial

    function Redirect()
    {
        let urlDestino = ""
        let state = {}        

        if(docData.tipoDoc !== TIPO.GuiaPag)
        {
            if (procData)
            {
                docData["numProc"] = procData.numProc
                docData["anoProc"] = procData.anoProc
            }
            urlDestino = Links.GERAR_DOCUMENTO
        
            state =
            {
                taxResults: docData.taxas,
                dadosDoc:
                {
                    procData: procData,
                    ...docData,
                    guiaOrigemData: procData?.documentos?.filter(doc => doc.id === docData.idGuiaOrigem)[0]
                }
            }
        }
        else
        {
            urlDestino = Links.GERAR_GUIA_DE_PAGAMENTO
            const guiaData = 
            {
                idServico: docData.tipoDoc,
                tipoServico: docData.tipoDoc,
                ...docData,
                taxResults: docData.tipoDoc === TIPO.DirDrenagem ? {TaxaTotal: 0.0} : {TaxaTotal: docData.taxas.taxaTotal}
            }

            state =
            {
                servicoTaxa:
                {
                    id: docData.detalhesGuia.tipoDocDestino,
                    nome: docData.tipoDoc
                },
                guiaData: guiaData,
                taxInputs: guiaData?.detalhesGuia?.taxInputs,
                taxResults: docData.taxas
            }
        }

        state =
        {
            ...state,
            editar: true,
            procData:
            {
                numProc: procData.numProc,
                anoProc: procData.anoProc,
                id: procData.id
            },
            linkPrevPage: Links.VER_PROCESSO,
            statePrevPage: prevState
        }

        navigate(urlDestino, {state: state})
    }

    return(
        <CustomTooltip 
            htmlObj={<Button className={btnStyle} variant={btnVariant} onClick={Redirect} disabled={!enabled}><img src={iconEdit} alt="Botão de editar documento" /></Button>} 
            text={"Editar documento"}
        />
    ) 
}

const ButtonDownloadDocumento = ({ procData, docData }) =>
{
    async function BaixarDoc()
    {

        if (!docData.tipoDoc) { console.log("Tentando baixar um documento sem tipo definido") ; return }

        switch (docData.tipoDoc)
        {
            case "GuiaPag":
                const filename = "Guia de pagamento - Proc N° " + docData.numProc + "-" + docData.anoProc

                await BaixarDocFromID(procData.id, docData.id, filename, true)

                return

            default:
                await BaixarDocFromID(procData.id, docData.id, docData.tipoDoc, true)
                return
        }
    }
    return(
        <CustomTooltip 
            htmlObj={<Button className={btnStyle} variant={btnVariant} onClick={BaixarDoc}><img src={iconPdf} alt="Botão de baixar pdf" /></Button>} 
            text={"Baixar documento"}/>
    ) 
}

const ButtonGerarDoc = ({ procData, guiaData, myState, disabled }) =>
{
    const navigate = useNavigate()

    const RedirectToGerarDocumento = () =>
    {
        navigate(Links.GERAR_DOCUMENTO, {state: {editar: false, procData: procData, guiaData: guiaData, statePrevPage: myState, linkPrevPage: Links.VER_PROCESSO }})
    }

    // TODO substituir por servicosTaxas com docGerado == undefined
    const buttonEnabled = guiaData.tipoDoc === "GuiaPag"
                            && !guiaData.fatoGerador.includes("Protocolo de Entrada")
                            // && !guiaData.fatoGerador.includes("Certidão de Demolição com Autorização")
                            // && !guiaData.fatoGerador.includes("Certidão de Demolição sem Autorização")
                            && !guiaData.fatoGerador.includes("Certidão de Retificação de Endereço e Número")
                            // Documentos do urbDocs
                            // && !guiaData.fatoGerador.includes("Certidão de Regularização")
                            // && !guiaData.fatoGerador.includes("Certidão de Habite-se")
                            // && !guiaData.fatoGerador.includes("Habite-se fora do prazo")

    return(
        <CustomTooltip 
            htmlObj={
            <Button className={btnStyle}
                    disabled={!buttonEnabled}
                    variant={btnVariant}
                    onClick={RedirectToGerarDocumento}>
                    <img src={iconGerarDoc} alt="Gerar doc" />
            </Button>} 
            text={"Gerar documento"}/>
    ) 

}

const ButtonTornarOficial = ({ procData, docData, refreshDocsOficiais, enabled }) =>
{
    const [modalShow, setModalShow] = useState(false);

    async function oficializar()
    {
        if (docData.tipoDoc === "Multa")
        {
            await oficializarMulta(docData.numDoc, docData.anoDoc)
        }
        else
        {
            await oficializarDocumentoPorID(procData.id, docData.id)
        }

        setModalShow(false)
        refreshDocsOficiais()
    }        

    return(
        <>
            <CustomTooltip 
                htmlObj={<Button className={btnStyle} variant={btnVariant} onClick={() => setModalShow(true)} disabled={!enabled}><img src={iconOficializar} alt="Botão de tornar o documento oficial" /></Button>} 
                text={"Oficializar documento"}/>
            <BotaoComModalConfirmacao
                    titulo={"Confirmação"}
                    texto={"Você está prestes a tornar esse documento oficial, você tem certeza que deseja fazer isso? Após torna-lo oficial você não poderá fazer mais modificações."}
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    onContinue={oficializar}
                    onContinueLoads={true}
            />
        </>
    )
}

const ButtonExcluir = ({ procData, docData, refreshDocsOficiais, enabled }) =>
{
    const [modalShow, setModalShow] = useState(false);

    async function excluir() 
    {
        await excluirDocumentoPorID(procData.id, docData.id) ; 
        setModalShow(false);
        refreshDocsOficiais();
    }

    return(
        <>
            <CustomTooltip 
                htmlObj={<Button className={btnStyle} variant={btnVariant} onClick={() => setModalShow(true)} disabled={!enabled}><img src={iconTrash} alt="Botão de excluir pdf" /></Button>} 
                text={"Excluir documento"}/>
            
            <BotaoComModalConfirmacao
                titulo={"Confirmação"}
                texto={"Você está prestes a excluir esse documento, você tem certeza que deseja fazer isso? Essa ação é irreversível!"}
                show={modalShow}
                onHide={() => setModalShow(false)}
                onContinue={excluir}
                onContinueLoads={true}
            />
        </>
    )
        
}

    
const TabelaDeDocumentos = ({ procData, refreshDocs, statePagina }) =>
{
    const title = `Documentos do processo ${procData.numProc}/${procData.anoProc}`
    const headers = [
        {
            varName: "numDoc",
            name: "Nº Documento",
            sortable: true
        },
        {
            varName: "anoDoc",
            name: "Ano Documento",
            sortable: true
        },
        {
            varName: "autenticacao.funcionarios.0.nome",
            name: "Analista",
            sortable: true
        },
        {
            varName: "servico",
            name: "Serviço",
            sortable: true
        },
        {
            varName: "createdAt",
            name: "Data de criação",
            sortable: true
        },
        {
            varName: "status",
            name: "Status",
            sortable: true
        },
        {
            varName: "actions",
            name: "Ações",
            sortable: false
        }
    ]
    // console.log(procData.documentos)
    const docsWithAction = procData.documentos.map(
        element => {
            const docIsEditavel = !element.oficial && (userData().matricula === element.autenticacao.funcionarios[0].matricula || userHasAccess(ROLE.GESTOR))
            return {
                ...element, 
                status: element.oficial? "Oficial" : "Rascunho",
                servico: element.fatoGerador === ""? TIPONOME[element.tipoDoc] + (tipoImovelNome[element.subTipoDoc] ? " - " + tipoImovelNome[element.subTipoDoc] : ""): "Guia - " + element.fatoGerador,
                actions:
                    <div className="d-flex flex-row align-items-center">
                        <ButtonVerDocumento procData={procData} docData={element} prevState={statePagina} />
                        <ButtonDownloadDocumento procData={procData} docData={element}  />
                        <ButtonEditarDocumento procData={procData} docData={element} prevState={statePagina} />
                        <ButtonGerarDoc procData={procData} guiaData={element} myState={statePagina}/>
                        <ButtonTornarOficial procData={procData} docData={element} enabled={docIsEditavel} refreshDocsOficiais={refreshDocs} />
                        <ButtonExcluir procData={procData} docData={element} enabled={docIsEditavel} refreshDocsOficiais={refreshDocs} />
                    </div>  
            }
        }
    )
    return(
        <Tabela title={title} headers={headers} elements={docsWithAction} msgNenhumEncontrado={"Nenhum documento encontrado"} filterParticipo={filterDocumentosQueParticipo} />
    )
}

export const VerProcessoScreen = () =>
{
    const location = useLocation()
    const {linkPrevPage, statePrevPage} = location.state
    // console.log(location.state)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const procPassado = location.state.procData
    const idProcPassado = procPassado.id 
    const [processo, setProcesso] = useState(null)
    
    function getProcInfo()
    {
        setLoading(true)
    }

    useEffect(() => {
        if(processo != null)
        {
            setLoading(false)
        }
    }, [processo])

    useEffect(() => {
        async function fetchProcesso(id)
        {
            const processoBD = await PegarProcessoPorID(id)
            setProcesso(processoBD)
        }
        if(loading)
        {
            fetchProcesso(idProcPassado)
        }
    }, [loading, idProcPassado])
    
    if (!userLogado) { navigate(Links.SEM_PERMISSAO) }

    if (procPassado === null || procPassado === undefined) { return <MsgNaoHaDadosDoProcesso /> }

    return (
        <div className="container bg-white border border-dark rounded-5 mb-3 shadow">
            
            <div className = "d-flex flex-column align-items-center mb-1">
                {
                loading?
                <Spinner className="my-5" animation="border" variant="primary" />
                :
                <TabelaDeDocumentos procData={processo} refreshDocs={getProcInfo} statePagina={location.state} />
                }
                <BotaoVoltar linkPrevPage={linkPrevPage} statePrevPage={statePrevPage} />
            </div>
        </div>
    )
}